import styled from 'styled-components';

import { EmptyState } from '@thinkific/toga-react';

const wrapped = styled(EmptyState)`
  h2 {
    font-family: inherit;
  }
`;

export default wrapped;
